import { CurrencyCodes } from '@onevesthq/ov-enums';
import { currencySymbol } from '@utils/currency';
import { formatMoneyValue } from '@utils/moneyFormatting';
import {
  Box,
  Typography,
  type TypographyProps,
  type TypographyVariant,
} from 'hephaestus/web';

type ValueSuperscriptedCentsProps = {
  value?: number;
  mainVariant: TypographyVariant;
  centsVariant: TypographyVariant;
  currency?: CurrencyCodes;
  color?: string;
  testId?: string;
  mainSx?: TypographyProps['sx'];
  centsSx?: TypographyProps['sx'];
};

export const ValueSuperscriptedCents = ({
  value,
  mainVariant,
  centsVariant,
  currency,
  color,
  testId = 'value-scripted-cents',
  mainSx,
  centsSx,
}: ValueSuperscriptedCentsProps) => {
  const formattedValue = formatMoneyValue(
    value,
    currencySymbol[currency ?? CurrencyCodes.CAD],
    undefined,
    false,
  );
  const [mainValue, centsValue] = formattedValue.split(
    formattedValue.includes('.') ? '.' : ',',
  );

  return (
    <Box
      data-testid={testId}
      sx={{
        display: 'flex',
      }}
    >
      <Typography
        variant={mainVariant}
        sx={[{ fontVariant: 'tabular-nums', color }, mainSx as any]}
      >
        {mainValue}
      </Typography>
      <Typography
        variant={centsVariant}
        sx={[{ fontVariant: 'tabular-nums', color }, centsSx as any]}
      >
        {formattedValue.includes('.') ? '.' : ','}
        {centsValue ?? '00'}
      </Typography>
    </Box>
  );
};
